/**
 * Explanatory note under the Eligible Game Spares section. These players have
 * responded to an availability request but are not on the game roster until
 * they are promoted, which is not obvious from the row actions alone.
 */
// Kept short so it stays on ONE line at the smallest supported phone width —
// a longer sentence wraps to two lines on mobile at this font size.
export const ELIGIBLE_GAME_SPARES_NOTE =
  'Players must be promoted to join the game roster.'
